import { Box, Chip, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import serviceRequestIcon from '../../assets/service-request.svg';
import React, { useEffect, useRef, useState } from 'react';
import PageHeader from 'components/Header/Page';
import DateFilterDropdown from 'components/Dropdown/DateFilter';
import { useCacheDataController } from 'Context/contexts/CacheDataContext';
import ReactECharts from 'echarts-for-react';
import { CustomizedDataGrid } from 'components/customized_data_grid';
import LoaderComponent from 'components/Loader';
import { exportDEIncidentDetails, fetchDEIncidentDetails, fetchServiceRequestSummary, getDataEstateKpiSector, getDataEstateSector } from 'service/service';
import moment from 'moment';
import { Column } from 'react-data-grid';
import { convertDecimalToTime, convertShortDateToActualDateFormat, formatNumberWithCommas } from 'utils/common-util';
import DoughnutChartWidget from 'components/Widgets/DoughnutWidget';
import SectorFilter from 'components/Dropdown/SectorFilter';
import { sectorListDetails } from 'Context/contexts/cacheData/DataEstate/type';
import GuageWidget from 'components/Widgets/GaugeWidget';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import { useTheme } from '@mui/material/styles';
 
const majorIncident = () => {
	const [controller] = useCacheDataController();
	const theme = useTheme();
	const colors = theme.palette;
	const { deMetricsLastSyncDate } = controller;
	const [dateFilter, setDateFilter] = useState<any>('Apr 2024');
	const [customMonth, setCustomMonth] = useState('');
	const [filterMonth, setFilterMonth] = useState<any>(localStorage.getItem('deMajorIncident') == 'true' ? localStorage.getItem('deIncidentDetailSelectedDate') : '0Y');
	const [filterDefaultMonth, setFilterDefaultMonth] = useState<any>(localStorage.getItem('deMajorIncident') == 'true' ? localStorage.getItem('deIncidentDetailSelectedDate') : '0Y');
	const [chartType, setChartType] = useState('');
	const [dimension, setDimension] = useState('');
	const [sectorName, setSectorName] = useState('all');
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [allSectorOptionsList, setAllSectorOptionsList] = useState<sectorListDetails | null>(null);
	const [sectorTagList, setSectorTagList] = useState<any>({ incident: true, outage: true});
	const [availabilityLoader, SetAvailabilityLoader] = useState<boolean>(true);
	const [availability, SetAvailability] = useState({});

	const [allSectorIncidentTotal, setAllSectorIncidentTotal] = useState(() => {
		const sectorData = localStorage.getItem('incidentTotal');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorOutageTotal, setAllSectorOutageTotal] = useState(() => {
		const sectorData = localStorage.getItem('outageTotal');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorAvailabilityData, setAllSectorAvailabilityData] = useState(() => {
		const sectorData = localStorage.getItem('availability');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorMTTRTotal, setAllSectorMTTRTotal] = useState(() => {
		const sectorData = localStorage.getItem('mttrTotal');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorIncidentData, setAllSectorIncidentData] = useState(() => {
		const sectorData = localStorage.getItem('incidentData');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorOutageData, setAllSectorOutageData] = useState(() => {
		const sectorData = localStorage.getItem('outageData');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorMTTRData, setAllSectorMTTRData] = useState(() => {
		const sectorData = localStorage.getItem('mttrData');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorIncidentDetailData, setAllSectorIncidentDetailData] = useState(() => {
		const sectorData = localStorage.getItem('incidentDetailsData');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	
	const [allSectorIncidentDetailPageData, setAllSectorIncidentDetailPageData] = useState(() => {
		const sectorData = localStorage.getItem('incidentDetailsPage');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	
	const [allSectorIncidentDetailsPageNumberData, setAllSectorIncidentDetailsPageNumberData] = useState(() => {
		const sectorData = localStorage.getItem('incidentDetailsPageNumber');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	
	const [allSectorIncidentDetailsSizeData, setAllSectorIncidentDetailsSizeData] = useState(() => {
		const sectorData = localStorage.getItem('incidentDetailsSize');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const [allSectorIncidentDetailsSortingInfoData, setAllSectorIncidentDetailsSortingInfoData] = useState(() => {
		const sectorData = localStorage.getItem('incidentDetailsSortingInfo');
		return sectorData != undefined ? JSON.parse(sectorData) : null;
	});

	const applyDateFilter = (selectedDate: any) => {
		getMajorIncidentsFunc(selectedDate);
		setDateFilter(selectedDate);
	};

	const formatNumberByUnits = (number: number) => {
		if (number >= 1000000) {
			return `${new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(
				number / 1000000
			)}MM`;
		}
		if (number >= 1000) {
			return `${formatNumberWithCommas((number / 1000).toFixed(2), true)}K`;
		}
		return new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(number);
	};

	interface Row {
		incidentId: string,
		relatedProblem: string,
		shortDescription: string,
		configurationItem: string,
		classDescription: string,
		openedDate: string,
		closedDate: string,
		resolvedDate: string,
		priority: string,
		businessCriticality: string,
		assignmentGroup: string,
		assignedTo: string,
		vendorName: string,
		status: string,
		outageType: string,
		serviceOffering: string,
		category: string,
		subCategory: string,
		mttr: string
	}

	const renderStatus = (status: any) => {
		switch (status) {
			case 'closed':
				return <Chip label={status} color="success" />;
			case 'open':
				return <Chip label={status} style={{ backgroundColor: '#299BFF26', color: '#299BFF' }} />;
			default:
				return <Chip label={status} style={{ backgroundColor: '#299BFF26', color: '#299BFF' }} />;
		}
	};

	const setdateFilter = () => {
		localStorage.setItem('deIncidentDetailSelectedDate', filterMonth);
		localStorage.setItem('deMajorIncident', 'false');
	}
	function getColumns(): Array<Column<Row>> {
		return [
			{
				key: 'incidentId',
				name: 'Incident ID',
				minWidth: 120,
				width: 120,
				formatter(props) {
						return props.row.incidentId
				},
			},
			// {
			// 	key: 'relatedProblem',
			// 	name: 'Related Problem',
			// 	width: 140,
			// 	minWidth: 140
			// },
			{
				key: 'shortDescription',
				name: 'Short Description',
				width: 230,
				minWidth: 200,
				formatter(props) {
					const data = props.row.shortDescription ? props.row.shortDescription : '-';
					return <div title={props.row.shortDescription} className='has-ellipsis'>{data}</div>;
				}
			},
			{
				key: 'configurationItem',
				name: 'Configuration Item Name',
				width: 230,
				minWidth: 200
			},
			{
				key: 'classDescription',
				name: 'Class Description',
				width: 230,
				minWidth: 200
			},
			{
				key: 'openedDate',
				name: 'Open Date',
				minWidth: 150,
				formatter(props: any) {
					const openedDate = props.row.openedDate;
					if (openedDate !== 'undefined' && openedDate !== null) {
						return moment(openedDate).format('MM-DD-YY HH:mm:ss');
					}
					return '';
				}
			},
			{
				key: 'outageStartTime',
				name: 'Outage Start Time',
				minWidth: 150,
				formatter(props: any) {
					const outageStartTime = props.row.outageStartTime;
					if (outageStartTime !== 'undefined' && outageStartTime !== null) {
						return moment(outageStartTime).format('MM-DD-YY HH:mm:ss');
					}
					return '';
				}
			},
			{
				key: 'outageEndTime',
				name: 'Outage End Time',
				minWidth: 150,
				formatter(props: any) {
					const outageEndTime = props.row.outageEndTime;
					if (outageEndTime !== 'undefined' && outageEndTime !== null) {
						return moment(outageEndTime).format('MM-DD-YY HH:mm:ss');
					}
					return '';
				}
			},
			{
				key: 'outageDuration',
				name: 'Outage Duration',
				minWidth: 150,
				formatter(props: any) {
					const outageDuration = props.row.outageDuration;
					if (outageDuration !== 'undefined' && outageDuration !== null) {
						return decimalHoursToHMS(outageDuration);
					}
					return '';
				}
			},
			{
				key: 'outageType',
				name: 'Outage Type',
				width: 150,
				minWidth: 150
			},
			{
				key: 'closedDate',
				name: 'Close Date',
				minWidth: 150,
				formatter(props: any) {
					const closedDate = props.row.closedDate;
					if (closedDate !== 'undefined' && closedDate !== null) {
						return moment(closedDate).format('MM-DD-YY HH:mm:ss');
					}
					return '';
				}
			},
			{
				key: 'resolvedDate',
				name: 'Resolve Date',
				minWidth: 150,
				formatter(props: any) {
					const resolvedDate = props.row.resolvedDate;
					if (resolvedDate !== 'undefined' && resolvedDate !== null) {
						return moment(resolvedDate).format('MM-DD-YY HH:mm:ss');
					}
					return '';
				}
			},
			{
				key: 'priority',
				name: 'Priority',
				minWidth: 130,
				width: 130,
			},
			{
				key: 'businessCriticality',
				name: 'Business Criticality',
				width: 190,
				minWidth: 190
			},
			{
				key: 'assignmentGroup',
				name: 'Assignment Group',
				width: 230,
				minWidth: 200,
				formatter(props) {
					const data = props.row.assignmentGroup ? props.row.assignmentGroup : '-';
					return <div title={props.row.assignmentGroup} className='has-ellipsis'>{data}</div>;
				}
			},
			{
				key: 'serviceOffering',
				name: 'Service Offering',
				width: 230,
				minWidth: 200,
				formatter(props) {
					const data = props.row.serviceOffering ? props.row.serviceOffering : '-';
					return <div title={props.row.serviceOffering} className='has-ellipsis'>{data}</div>;
				}
			},
			{
				key: 'category',
				name: 'Category',
				width: 230,
				minWidth: 200,
				formatter(props) {
					const data = props.row.category ? props.row.category : '-';
					return <div title={props.row.category} className='has-ellipsis'>{data}</div>;
				}
			},
			{
				key: 'subCategory',
				name: 'Sub Category',
				width: 230,
				minWidth: 200,
				formatter(props) {
					const data = props.row.subCategory ? props.row.subCategory : '-';
					return <div title={props.row.subCategory} className='has-ellipsis'>{data}</div>;
				}
			},
			{
				key: 'assignedTo',
				name: 'Assigned To',
				minWidth: 125,
				width: 125
			},
			{
				key: 'mttr',
				name: 'MTTR',
				width: 150,
				minWidth: 150,
				formatter(props) {
					const data = props.row.mttr ? Number(props.row.mttr).toFixed(2) : '-';
					return <div title={props.row.mttr} className='has-ellipsis'>{data}</div>;
				}
			},
			// {
			// 	key: 'vendorName',
			// 	name: 'Vendor Name',
			// 	minWidth: 130,
			// 	width: 130,
			// },
		];
	}
	const [checkedList, setCheckedList] = useState<any[]>([]);
	const [MTTRData, SetMTTRData] = useState([]);
	const [IncidentsData, SetIncidentsData] = useState([]);
	const [OutagesData, SetOutagesData] = useState<any>({});
	const [MTTRDataObject, SetMTTRDataObject] = useState<any>({});

	const [doughnutMTTRTotal, setDoughnutMTTRTotal] = useState<any>();
	const [doughnutSeriesData, setDoughnutSeriesData] = useState<any>([]);
	const [MTTRLoading, setMTTRLoading] = useState(true);

	const [doughnutIncidentTotal, setDoughnutIncidentTotal] = useState<any>();
	const [doughnutIncSeriesData, setDoughnutIncSeriesData] = useState<any>([]);
	const [incidentLoading, setIncidentLoading] = useState(true);

	const [doughnutOutagTotal, setDoughnutOutageTotal] = useState<any>();
	const [doughnutOutageSeriesData, setDoughnutOutageSeriesData] = useState<any>([]);
	const [OutageLoading, setOutageLoading] = useState(true);

	const [incidentDetails, setIncidentDetails] = useState<Row[]>([]);
	const [loading, setLoading] = useState(false);
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const totalElements = paginationData?.totalElements || 0;
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);

	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [filterData, setFilterData] = useState<Row[]>([]);
	const [filterInfo, setFilterInfo] = useState([]);
	const [searchDetails, setFilterSearchInfo] = useState([]);

	const defaultColumnNames = [
		'Incident ID',
		// 'Related Problem',
		'Short Description',
		'Configuration Item Name',
		'Open Date',
		'Outage Start Time',
		'Outage End Time',
		'Outage Duration',
		'Resolve Date',
		'Close Date',
		'Priority',
		'Business Criticality',
		'Assignment Group',
		'Service Offering',
		'Category',
		'Sub Category',
		'Assigned To',
		// 'Vendor Name',
		'Status'
	];

	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		incidentsDetailFunc(value, pageSize, sortingInfo, parseFilter(filterInfo), filterMonth, chartType, dimension, sectorName);
	};

	const handlepageSizeChange = (event: any) => {
		incidentsDetailFunc('1', event.target.value, sortingInfo, parseFilter(filterInfo), filterMonth, chartType, dimension, sectorName);
	};
	const handleSorting = (sortingInfo: any) => {
		incidentsDetailFunc(page, pageSize, sortingInfo, parseFilter(filterInfo), filterMonth, chartType, dimension, sectorName);
	};

	function decimalHoursToHMS(decimalHours: any) {
		// Calculate hours
		const hours = Math.floor(decimalHours);
		// Calculate remaining minutes from the decimal part
		const minutes = Math.floor((decimalHours - hours) * 60);
		// Calculate seconds from the remaining decimal part of minutes
		const seconds = Math.round(((decimalHours - hours) * 60 - minutes) * 60);

		// Format the output
		if (hours === 0 && minutes === 0) {
			return `${seconds ? seconds : 1} Seconds`;
		} else if (hours === 0) {
			return `${minutes} Minutes and ${seconds} Seconds`;
		} else {
			return `${hours} Hours, ${minutes} Minutes, and ${seconds} Seconds`;
		}
	}

	const handleFilter = (filterInfo: any) => {
		setFilterInfo(filterInfo);
		incidentsDetailFunc(1, pageSize, sortingInfo, parseFilter(filterInfo), filterMonth, chartType, dimension, sectorName);
	};
	const handleSearch = (searchDetails: any, columnKey: any) => {
		incidentSearchFunc(searchDetails, parseFilter(filterInfo, columnKey), columnKey);
	};

	const parseFilter = (filterInfo: any, name?: string) => {
		// Call only filterable columns and reset the filtering in case of wrong/empty column
		const parsedFilter: any = {};
		Object.keys(filterInfo).forEach((key: any) => {
			if (key !== name && filterInfo[key] && filterInfo[key].length) {
				parsedFilter[key] = filterInfo[key];
			}
		});
		return parsedFilter;
	};

	async function getMajorIncidentsFunc(selectedDate?: string, sector?: string) {
		setLoading(true);

		// Function to get color by team name
		const getColorByTeam = (team: string) => {
			switch (team) {
				case 'Legacy EDW':
					return '#00B4C5';
				case 'Azure':
					return '#00BF7D';
				case 'Databricks':
					return '#F57600';
				case 'Presto':
					return '#E6308A';
				default:
					return '#299BFF';
			}
		};

		if (sector == 'Blank') sector = '';

		const formattedDate = convertShortDateToActualDateFormat(selectedDate);
		// let azureData = {
		// 	"distinctIncidentCount": 0,
		// 	"Assignment_Group_Name": "INFRA AZURE CLOUD"
		// }

		// if ((selectedDate != '' && selectedDate != '0Y' && selectedDate != '0M' && selectedDate != '1M') &&
		// 	(
		// 		(selectedDate?.includes('-') && selectedDate == '2024-12') ||
		// 		selectedDate?.includes('M') || selectedDate?.includes('Y')
		// 	)) {
		// 	azureData.distinctIncidentCount = 1
		// }

		fetchServiceRequestSummary('MTTR', selectedDate, sector, formattedDate)
			.then((res) => {
				SetMTTRData(res?.data?.result);
				const data: any = { 'Legacy EDW': null, Azure: null, Databricks: null, Presto: null, Others: null };
				let totalSum = 0;
				const mttrResult = res?.data?.result.groupAverages;
				if (mttrResult['Legacy EDW'] !== null) {
					data['Legacy EDW'] = mttrResult['Legacy EDW'];
				}
				if (mttrResult['Azure'] !== null) {
					data['Azure'] = mttrResult['Azure'];
				}
				if (mttrResult['Databricks'] !== null) {
					data['Databricks'] = mttrResult['Databricks'];
				}
				if (mttrResult['Others'] !== null) {
					data['Others'] = mttrResult['Others'];
				}

				const average = res?.data?.result.totalAverage[0].totalAvg;
				let seriesData = Object.keys(data).map((team: string) => ({
					name: team,
					value: data[team],
					percentage: ((data[team] / totalSum) * 100).toFixed(2),
					formattedName: `${((data[team] / totalSum) * 100).toFixed(2)}%`,
					color: getColorByTeam(team) // Add color based on team
				}));
				if (sector == 'all') {
					localStorage.setItem('mttrTotal', formatNumberByUnits(average || 0));				
					localStorage.setItem('mttrData', JSON.stringify(seriesData));
				}
				setDoughnutMTTRTotal(formatNumberByUnits(average || 0));
				setDoughnutSeriesData(seriesData);
				setMTTRLoading(false);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
			});

		fetchServiceRequestSummary('incidents', selectedDate, sector, formattedDate)
			.then((res) => {
				SetIncidentsData(res?.data?.result);
				const data: any = { 'Legacy EDW': null, Azure: null, Databricks: null, Presto: null, Others: null };
				let totalSum = 0;
				// if ((selectedDate != '' && selectedDate != '0Y' && selectedDate != '0M' && selectedDate != '1M') &&
				// 	(
				// 		(selectedDate?.includes('-') && selectedDate == '2024-12') ||
				// 		selectedDate?.includes('M') || selectedDate?.includes('Y')
				// 	)) {
				// 	res.data.result.push(azureData);
				// }
				res?.data?.result.forEach((incident: any) => {
					if (incident.Assignment_Group_Name !== null) {
						if (incident.Assignment_Group_Name === 'EDW PLATFORM TERADATA') {
							data['Legacy EDW'] = data['Legacy EDW'] + incident.distinctIncidentCount;
							totalSum = totalSum + incident.distinctIncidentCount;
						}
						if (incident.Assignment_Group_Name === 'INFRA AZURE CLOUD') {
							data['Azure'] = data['Azure'] + incident.distinctIncidentCount;
							totalSum = totalSum + incident.distinctIncidentCount;
						}
						if (
							incident.Assignment_Group_Name === 'ADVANCED ANALYTICS PLATFORM SUPPORT' ||
							incident.Assignment_Group_Name === 'ENTERPRISE DATA WAREHOUSE'
						) {
							data['Databricks'] = data['Databricks'] + incident.distinctIncidentCount;
							totalSum = totalSum + incident.distinctIncidentCount;
						}
						// if (incident.Presto != 0) {
						// 	data['Presto'] = data['Presto'] + incident.Presto;
						// 	totalSum += incident.Presto;
						// }
						if (
							incident.Assignment_Group_Name !== 'ADVANCED ANALYTICS PLATFORM SUPPORT' &&
							incident.Assignment_Group_Name !== 'EDW PLATFORM TERADATA' &&
							incident.Assignment_Group_Name !== 'ENTERPRISE DATA WAREHOUSE' &&
							incident.Assignment_Group_Name !== 'DATA INTEGRATION L3 SUPPORT NAB' &&
							incident.Assignment_Group_Name !== 'INFRA AZURE CLOUD' 
						) {
							data['Others'] = data['Others'] + incident.distinctIncidentCount;
							totalSum = totalSum + incident.distinctIncidentCount;
						}
					}
				});
				let seriesData = Object.keys(data).map((team: string) => ({
					name: team,
					value: data[team],
					percentage: ((data[team] / totalSum) * 100).toFixed(2),
					formattedName: `${((data[team] / totalSum) * 100).toFixed(2)}%`,
					color: getColorByTeam(team) // Add color based on team
				}));
				if (sector == 'all') {
					localStorage.setItem('incidentTotal', formatNumberByUnits(totalSum || 0));
					localStorage.setItem('incidentData', JSON.stringify(seriesData));
				}
				setDoughnutIncidentTotal(formatNumberByUnits(totalSum));
				setDoughnutIncSeriesData(seriesData);
				setIncidentLoading(false);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
			});

		fetchServiceRequestSummary('outage', selectedDate, sector, '')
			.then((res) => {
				SetOutagesData(res?.data?.result);
				const data: any = { 'Legacy EDW': null, Azure: null, Databricks: null, Presto: null, Others: null };
				let totalSum = 0;
				res?.data?.result.forEach((outage: any) => {
					// totalSum = 0;
					if (outage.Assignment_Group_Name !== null) {
						if (outage.Assignment_Group_Name === 'EDW PLATFORM TERADATA') {
							data['Legacy EDW'] = data['Legacy EDW'] + outage.distinctIncidentCount;
							totalSum = totalSum + outage.distinctIncidentCount;
						}
						if (outage.Assignment_Group_Name === 'INFRA AZURE CLOUD') {
							data['Azure'] = data['Azure'] + outage.distinctIncidentCount;
							totalSum = totalSum + outage.distinctIncidentCount;
						}
						if (
							outage.Assignment_Group_Name === 'ADVANCED ANALYTICS PLATFORM SUPPORT' ||
							outage.Assignment_Group_Name === 'ENTERPRISE DATA WAREHOUSE'
						) {
							data['Databricks'] = data['Databricks'] + outage.distinctIncidentCount;
							totalSum = totalSum + outage.distinctIncidentCount;
						}
						// if (outage.Presto != 0) {
						// 	data['Presto'] = data['Presto'] + outage.Presto;
						// 	totalSum += outage.Presto;
						// }
						if (
							outage.Assignment_Group_Name !== 'ADVANCED ANALYTICS PLATFORM SUPPORT' &&
							outage.Assignment_Group_Name !== 'EDW PLATFORM TERADATA' &&
							outage.Assignment_Group_Name !== 'ENTERPRISE DATA WAREHOUSE' &&
							outage.Assignment_Group_Name !== 'DATA INTEGRATION L3 SUPPORT NAB' &&
							outage.Assignment_Group_Name !== 'INFRA AZURE CLOUD' 
						) {
							data['Others'] = data['Others'] + outage.distinctIncidentCount;
							totalSum = totalSum + outage.distinctIncidentCount;
						}
					}
				});
				let seriesData = Object.keys(data).map((team: string) => ({
					name: team,
					value: data[team],
					percentage: ((data[team] / totalSum) * 100).toFixed(2),
					formattedName: `${((data[team] / totalSum) * 100).toFixed(2)}%`,
					color: getColorByTeam(team) // Add color based on team
				}));
				if (sector == 'all') {
					localStorage.setItem('outageTotal', formatNumberByUnits(totalSum || 0));
					localStorage.setItem('outageData', JSON.stringify(seriesData));
				}
				setDoughnutOutageTotal(formatNumberByUnits(totalSum));
				setDoughnutOutageSeriesData(seriesData);
				setOutageLoading(false);
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
			});

		fetchServiceRequestSummary('availability', selectedDate, sector, '')
			.then((res) => {
				const result = res?.data?.result ?? 0;
				const percentage = parseFloat(result.toFixed(2));
				const percentageColor = '#299BFF';
				const baseColor = '#ffffff';
				const textColor = '#111111';

				const AvailabilityOption = {
					backgroundColor: '#ffffff',
					series: [
						// Outer gauge (arc background + filled progress)
						{
							type: 'gauge',
							center: ['50%', '55%'],
							min: 0,
							max: 100,
							splitNumber: 5,
							itemStyle: { color: baseColor },
							progress: { show: false },
							pointer: { show: false },
							axisLine: {
								show: true,
								lineStyle: {
									width: 30,
									color: [
										[percentage / 100, percentageColor],
										[1, baseColor]
									]
								}
							},
							axisTick: { show: false },
							splitLine: { show: false },
							axisLabel: {
								distance: -50,
								color: textColor,
								fontSize: 12,
								formatter: (value: number) => `${value}%`
							},
							anchor: { show: false },
							title: { show: false },
							detail: {
								valueAnimation: true,
								width: '60%',
								lineHeight: 40,
								borderRadius: 8,
								offsetCenter: [0, 10],
								fontSize: 20,
								formatter: `${percentage}%`,
								color: textColor
							},
							data: [{ value: percentage }]
						},
						// Inner gauge (center label + filled bar)
						{
							type: 'gauge',
							center: ['50%', '55%'],
							min: 0,
							max: 100,
							itemStyle: { color: percentageColor },
							progress: { show: true, width: 20 },
							pointer: { show: false },
							axisLine: { show: false },
							axisTick: { show: false },
							splitLine: { show: false },
							axisLabel: { show: false },
							detail: {
								valueAnimation: true,
								width: '60%',
								lineHeight: 40,
								borderRadius: 8,
								offsetCenter: [0, '-20%'],
								fontSize: 14,
								fontWeight: 'normal',
								formatter: 'Availability',
								color: textColor
							},
							data: [{ value: percentage }]
						}
					]
				};
				if (sector == 'all') {
					localStorage.setItem('availability', JSON.stringify(AvailabilityOption));
				}
				SetAvailability(AvailabilityOption);
			})
			.catch((error) => {
				console.error('Error fetching availability:', error);
			})
			.finally(() => {
				SetAvailabilityLoader(false);
			});
	}

	async function incidentsDetailFunc(pageNumber: any, size: any, sortingInfo: any, jobFilterInfo: any, selectedDate: any, type: any, dimension: any, sector: string) {
		setLoading(true);
		if(sector == 'Blank')
			sector = '';

		if (pageSize !== size) {
			pageNumber = 1;
		}
		const res = await fetchDEIncidentDetails(sector, pageNumber.toString(), size.toString(), selectedDate, type, dimension);
		if (res.success) {
			if (res.data) {
				setIncidentDetails(res.data.data);
				setPaginationData(res.data.page);
				setPage(pageNumber);
				setPageSize(size);
				setSortingInfo(sortingInfo);
				setLoading(false);
				if (sector == 'all') {
					localStorage.setItem('incidentDetailsData', JSON.stringify(res.data.data));
					localStorage.setItem('incidentDetailsPage', JSON.stringify(res.data.page));
					localStorage.setItem('incidentDetailsPageNumber', JSON.stringify(pageNumber));
					localStorage.setItem('incidentDetailsSize', JSON.stringify(size));
					localStorage.setItem('incidentDetailsSortingInfo', JSON.stringify(sortingInfo));
				}
			}
		}
	}

		// export
		async function exportIncidentsDetailFunc(sortingInfo: any, jobFilterInfo: any, selectedDate: any, type: any, dimension: any, sector: string) {
			let exportColumns = [
				'Incident ID',
				'Short Description',
				'Configuration Item Name',
				'Open Date',
				'Outage Start Time',
				'Outage End Time',
				'Outage Duration',
				'Resolve Date',
				'Close Date',
				'Priority',
				'Business Criticality',
				'Assignment Group',
				'Service Offering',
				'Category',
				'Sub Category',
				'Assigned To'
			];
			let formatType = "EXCEL"
			let tableName = "Major Incident Details"
			
			await exportDEIncidentDetails(exportColumns, formatType, tableName, sector, selectedDate, type, dimension);
		};

	useEffect(() => {
		localStorage.setItem('deIncidentDetailSelectedDate', filterMonth);
		localStorage.setItem('deMajorIncident', 'false');
		incidentsDetailFunc(page, pageSize, sortingInfo, parseFilter(filterInfo), filterMonth, chartType, dimension, 'all');
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/dataestate/majorIncident') {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue');
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list');
				activeId.classList.remove('root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas');
				document.body.classList.add('datefilter-align-sector');
				document.body.classList.add('sector-label');
			}
		} else {
			if (activeId) {
				document.body.classList.remove('jobs-list-datas');
				activeId.classList.add('root');
				document.body.classList.add('dashboard-panel-dataestate');
				document.body.classList.add('datefilter-align-sector');
			}
		}
		fetchSectorOptionsData();
		getMajorIncidentsFunc(filterMonth,'all')

	}, []);

	useEffect(() => {
		const onDateChange = (event: any) => {
			const selectedDate = event?.detail?.selectedDate;
			if (selectedDate) {
				setFilterMonth(selectedDate);
				getMajorIncidentsFunc(selectedDate, sectorName);
				incidentsDetailFunc(page, pageSize, sortingInfo, parseFilter(filterInfo), selectedDate, chartType, dimension, sectorName);
			}
		};
		window.addEventListener('dataEstateDateChanged', onDateChange);
		return () => {
			window.removeEventListener('dataEstateDateChanged', onDateChange);
		};
	}, [sectorName]);

	async function incidentSearchFunc(searchDetails: any, jobFilterInfo: any, columnKey: any) {
		// const res = await jobSearch(searchDetails, jobFilterInfo, columnKey);
		// if (res.success) {
		// 	setFilterSearchInfo(res.data);
		// }
	}
	const handleDateChange = (selectedDate: string) => {
		incidentsDetailFunc(1, pageSize, sortingInfo, parseFilter(filterInfo), selectedDate, chartType, dimension, sectorName);
		getMajorIncidentsFunc(selectedDate, sectorName);
		setFilterDefaultMonth(selectedDate)
	};

	const handleINCReportOnclick = (param: any, title?: string) => {
		if (param && param.name) {
			if (chartType == title && dimension == param.name) {
				incidentsDetailFunc(page, pageSize, sortingInfo, param.name, filterMonth, '', '', sectorName);
				setChartType('');
				setDimension('');
			} else {
				incidentsDetailFunc(page, pageSize, sortingInfo, param.name, filterMonth, title, param.name, sectorName);
				setChartType(title != null ? title : '');
				setDimension(param.name)
			}
		}
	};

	async function fetchSectorOptionsData() { 
		let sectorKpi = [];
		sectorKpi.push("incident","outage");
		const sectorRes = await getDataEstateKpiSector(sectorKpi);
		if (sectorRes.success) {
			if(sectorRes.data) {
				setAllSectorOptionsList(sectorRes.data);
				const allSectors = [
					...sectorRes.data.incident.map((item: any) => item.sector),
					...sectorRes.data.outages.map((item: any) => item.sector)
				];
			}
		}
		const sectorKpiRes = await getDataEstateSector();
		if (sectorKpiRes.success) {
			if (sectorKpiRes.data) {
				const sectorValues = sectorKpiRes.data.map((item: { sector: any; }) => item.sector);
				const uniqueSectors = Array.from(new Set(sectorValues));
				const sectorNameList = uniqueSectors.map(sector =>
					sector === "" ? "Blank" : sector
				);
				setSectorOptionsList(sectorNameList.sort());
			}
		}
	}

	function formatMTTR(totalHours: number): string {
		const { Days, Hours, Minutes } = convertDecimalToTime(totalHours);
		return `${Days > 0 ? Days + ' Days\n' : ''} ${Hours > 0 ? Hours + ' Hrs' : ''} ${Minutes > 0 ? Minutes + ' Mins' : ''}`;
	}

	const handleSectorChange = (value: string) => {
		setLoading(true);
		setSectorName(value); 
		sectorTagUpdatefun(value);
	};

	const sectorTagUpdatefun = (sector: string) => {
		if(sector != 'all'){
			if(sector == 'Blank')
				sector = '';

			const isInIncident = allSectorOptionsList?.incident.some(item => item.sector === sector);
			const isInOutage = allSectorOptionsList?.outages.some(item => item.sector === sector);

			const filteredData = {
				incident: isInIncident || false,
				outage: isInOutage || false
			};
			setSectorTagList(filteredData);
			if(filteredData.incident == true) getMajorIncidentsFunc(filterMonth, filteredData.incident == true ? sector : 'all');
			if(filteredData.incident == true) incidentsDetailFunc(page, pageSize, sortingInfo, parseFilter(filterInfo),filterMonth, chartType, dimension, sector);
			if (!filteredData.incident) {
				setIncidentDetails(allSectorIncidentDetailData);
				setPaginationData(allSectorIncidentDetailPageData);
				setPage(allSectorIncidentDetailsPageNumberData);
				setPageSize(allSectorIncidentDetailsSizeData);
				setSortingInfo(allSectorIncidentDetailsSortingInfoData);
				setLoading(false);
			}
		} else {	
			const filteredData = {
				incident: true,
				outage: true
			};
			setSectorTagList(filteredData);
			getMajorIncidentsFunc(filterMonth, sector);
			incidentsDetailFunc(page, pageSize, sortingInfo, parseFilter(filterInfo),filterMonth, chartType, dimension, sector);
		}
	}

	return (
		<PageWrapper>
			{/* <PageHeader title="Major INC Summary" icon={serviceRequestIcon} lastSync={deMetricsLastSyncDate}> */}
				{/* <DateFilterDropdown
					customMonth={customMonth}
					filterMonth={filterMonth}
					setCustomMonth={setCustomMonth}
					setFilterMonth={setFilterMonth}
					handleChange={handleDateChange}
				/>
				<SectorFilter
					sectorName={sectorName}
					setSectorName={setSectorName}
					sectorOptionsList={sectorOptionsList}
					handleChange={handleSectorChange}
				/> */}
			{/* </PageHeader> */}
			<Grid container spacing={2} p={{ md: 2}} mt={1}>
				<Grid item xs={12} sm={6} md={3} id="details">
					<DoughnutChartWidget
						title={<HighlightedText text="Major INC Details" />}
						isLoading={incidentLoading}
						// seriesData={doughnutIncSeriesData}
						seriesData={
							sectorTagList?.incident == false
								? allSectorIncidentData
								: doughnutIncSeriesData
						}
						// totalText={`{small|Total}\n{large|${doughnutIncidentTotal}}`}
						totalText={
							sectorTagList?.incident == false
								? `{small|Total}\n{large|${allSectorIncidentTotal}}`
								: `{small|Total}\n{large|${doughnutIncidentTotal}}`
						}
						dataLabel={true}
						legendLabel={true}
						handleEvent={handleINCReportOnclick}
						sectorLabel={sectorTagList?.incident == true ? (sectorName == 'all' ? '' : sectorName) : ''}
						chartSize="250px"
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={3} id="outages">
					<DoughnutChartWidget
						title={<HighlightedText text="Outages" />}
						isLoading={OutageLoading}
						// seriesData={doughnutOutageSeriesData}
						seriesData={sectorTagList?.outage == false
								? allSectorOutageData
								: doughnutOutageSeriesData}
						// totalText={`{small|Total}\n{large|${doughnutOutagTotal}}`}
						totalText={
							sectorTagList?.outage == false
								? `{small|Total}\n{large|${allSectorOutageTotal}}`
								: `{small|Total}\n{large|${doughnutOutagTotal}}`
						}
						dataLabel={true}
						legendLabel={true}
						handleEvent={handleINCReportOnclick}
						sectorLabel={sectorTagList?.outage == true ? (sectorName == 'all' ? '' : sectorName) : ''}
						chartSize="250px"
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={3} id="mttr">
					<DoughnutChartWidget
						title={<HighlightedText text="Mean time To Resolve (MTTR)" />}
						isLoading={MTTRLoading}
						// seriesData={doughnutSeriesData}
						seriesData={sectorTagList?.incident == false
								? allSectorMTTRData
								: doughnutSeriesData}
						// totalText={`{small|Total Mean Time}\n{large|${formatMTTR(doughnutMTTRTotal)}}`}
						totalText={
							sectorTagList?.incident == false
								? `{small|Total Mean Time}\n{large|${formatMTTR(allSectorMTTRTotal)}}`
								: `{small|Total Mean Time}\n{large|${formatMTTR(doughnutMTTRTotal)}}`
						}
						dataLabel={true}
						legendLabel={true}
						hoursFormat={true}
						handleEvent={handleINCReportOnclick}
						sectorLabel={sectorTagList?.incident == true ? (sectorName == 'all' ? '' : sectorName) : ''}
						chartSize="250px"
					/>
				</Grid>
				<Grid item xs={12} sm={6} md={3} id="availability">
					<GuageWidget title={<HighlightedText text="Platform Availability" />} isLoading={availabilityLoader} 
						// data={availability} 
						color='#ffffff'
						data={sectorTagList?.incident == false 
								? allSectorAvailabilityData
								: availability} 
						sectorLabel={sectorTagList?.incident == true ? (sectorName == 'all' ? '' : sectorName) : ''}/>
				</Grid>
			</Grid>
			<Grid p={2} mt={0.5} id="inc-details">
				{!loading ? (
					<CustomizedDataGrid
						title={<HighlightedText text={chartType != '' && dimension != '' ? `${dimension} ${chartType}` : 'Incident Details'} />}
						tableColumns={getColumns()}
						tableData={incidentDetails && incidentDetails.length !== 0 ? incidentDetails : 0}
						tableType="incident-details-ver"
						defaultColumnNames={defaultColumnNames}
						onSorting={handleSorting}
						currSorting={sortingInfo}
						filterDataOptions={filterData}
						searchDataValues={searchDetails}
						onFilterCheck={handleFilter}
						currFilter={filterInfo}
						onFilterSearch={handleSearch}
						page={page}
						pageSize={pageSize}
						paginationData={{ totalElements }}
						listLength={incidentDetails && incidentDetails.length !== 0 ? incidentDetails.length : 0}
						handlepageSizeChange={handlepageSizeChange}
						handlePageChange={handlePageChange}
						isFetching={loading}
						showExport={true}
						fileName={`Jobs.xlsx`}
						isDateRangeFilter={false}
						isDisabled={false}
						exportTableData={() =>
							exportIncidentsDetailFunc(
								sortingInfo,
								parseFilter(filterInfo),
								filterMonth,
								chartType,
								dimension,
								sectorName
							)
						}
						isShowMoreButton
					/>
				) : (
					<LoaderComponent />
				)}
			</Grid>
		</PageWrapper>
	);
};

export default majorIncident;